/* Refonte V4 mobile — zone home (propriété exclusive de l'agent home).
   Rails produits : barre de progression sous le rail (indique qu'on peut glisser et où l'on en est). */
(function () {
  'use strict';
  function initRow(row) {
    var track = row.querySelector('.v4h-row__track');
    var bar = row.querySelector('.v4h-row__bar > span');
    if (!track || !bar) return;
    var raf = 0;
    function update() {
      raf = 0;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) { row.classList.add('is-static'); return; }
      row.classList.remove('is-static');
      var w = Math.max(18, Math.min(100, (track.clientWidth / track.scrollWidth) * 100));
      var p = Math.min(1, Math.max(0, track.scrollLeft / max));
      bar.style.setProperty('--w', w + '%');
      // translateX en % de la largeur du curseur : (100 - w) / w * 100 * p
      bar.style.setProperty('--x', ((100 - w) / w) * 100 * p);
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(update); }
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
  }
  function init() { document.querySelectorAll('[data-v4h-row]').forEach(initRow); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
